module.exports = __webpack_public_path__ + "img/player-pause-icon.38f7348f.svg";